
define('text!modules/reporting/campaigns/dataExport/createEdit/templates/selectors.html',[],function () { return '<div class="dimensions-selector"></div>\n<div class="v-separator"></div>\n<div class="metrics-selector"></div>\n';});

